/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainEntitiesDocumentsDocumentContent, FxIdDomainEntitiesDocumentsDocumentContentFromJSONTyped, FxIdDomainEntitiesDocumentsDocumentContentToJSON, } from './FxIdDomainEntitiesDocumentsDocumentContent';
export function FxIdDomainEntitiesDocumentsGameDocumentVersionContentFromJSON(json) {
    return FxIdDomainEntitiesDocumentsGameDocumentVersionContentFromJSONTyped(json, false);
}
export function FxIdDomainEntitiesDocumentsGameDocumentVersionContentFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainEntitiesDocumentsDocumentContent(json)) {
        return FxIdDomainEntitiesDocumentsDocumentContentFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainEntitiesDocumentsGameDocumentVersionContentToJSON(json) {
    return FxIdDomainEntitiesDocumentsGameDocumentVersionContentToJSONTyped(json, false);
}
export function FxIdDomainEntitiesDocumentsGameDocumentVersionContentToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainEntitiesDocumentsDocumentContent(value)) {
        return FxIdDomainEntitiesDocumentsDocumentContentToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainEntitiesDocumentsGameDocumentVersionContent.js.map